import React from 'react';
import PropTypes from 'prop-types';

import { FieldWrapper, FieldLabelWrapper } from './css';
import FieldGuide from './common/fieldGuide';
import FieldTitle from './common/FieldTitle';

const FieldFile = ({ data }) => {
  const {
    name,
    label,
    required,
    onChange,
    tooltip,
    allowedFileTypes,
    tooltipLong,
    toolTipRichText
  } = data;
  const tooltipMessage = tooltip || tooltipLong || toolTipRichText;
  return (
    <FieldWrapper>
      <div>
        <FieldLabelWrapper>
          <FieldTitle required={required} label={label} />
          {tooltipMessage && (
            <FieldGuide tooltip={tooltipMessage} isRichText={toolTipRichText} />
          )}
        </FieldLabelWrapper>
      </div>
      <input
        type="file"
        name={name}
        accept={allowedFileTypes}
        onChange={onChange}
      />
    </FieldWrapper>
  );
};

FieldFile.propTypes = {
  data: PropTypes.shape({
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    required: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    tooltip: PropTypes.string,
    tooltipLong: PropTypes.string,
    toolTipRichText: PropTypes.shape({
      content: PropTypes.arrayOf(PropTypes.object)
    }),
    allowedFileTypes: PropTypes.string
  }).isRequired
};

export default FieldFile;
